import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Size2b01934yxlz5f as Size,
  Companion_getInstanceihdke9ufrn8x as Companion_getInstance,
} from '../../models/Rect.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  measureByDuplicate50c5johgli0l as measureByDuplicate,
  resizeObserver1rxn81hcox9er as resizeObserver,
  mutationObserver1idzofyamtyii as mutationObserver,
} from './helpers.commonHtml.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { AllFull_instance2nn1g6bx2959d as AllFull_instance } from './ProgrammaticLayout.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  get_px1lajc6xaddk2r as get_px,
  get_viewUnits3uus4yl4di64 as get_viewUnits,
} from '../../models/data.js.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../models/data.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function remeasureConstrainedSize($this) {
  var tmp = $this.tb5_1.vb3_1;
  var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var element = tmp_0;
  var tmp_1 = element.parentElement;
  var tmp1_elvis_lhs = tmp_1 instanceof HTMLElement ? tmp_1 : null;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var parentElement = tmp_2;
  var tmp2_safe_receiver = $this.jdi_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.fcv(['Remeasuring the parent element constraint']);
  }
  $this.vdi_1 = parentElement.clientWidth;
  $this.wdi_1 = parentElement.clientHeight;
  var tmp_3 = $this;
  // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
  var tmp_4 = $this.tb5_1.bb4_1.fb7_1.flexGrow;
  var tmp3_safe_receiver = (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : null;
  var tmp_5;
  if (tmp3_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_6;
    if (!isBlank(tmp3_safe_receiver)) {
      tmp_6 = tmp3_safe_receiver;
    } else {
      tmp_6 = null;
    }
    tmp_5 = tmp_6;
  }
  tmp_3.qdi_1 = tmp_5;
  var tmp_7 = $this;
  // Inline function 'com.lightningkite.kiteui.views.width' call
  var tmp_8 = $this.tb5_1.bb4_1.fb7_1.width;
  var tmp4_safe_receiver = (!(tmp_8 == null) ? typeof tmp_8 === 'string' : false) ? tmp_8 : null;
  var tmp_9;
  if (tmp4_safe_receiver == null) {
    tmp_9 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_10;
    if (!(tmp4_safe_receiver === $this.tdi_1 || isBlank(tmp4_safe_receiver))) {
      tmp_10 = tmp4_safe_receiver;
    } else {
      tmp_10 = null;
    }
    tmp_9 = tmp_10;
  }
  tmp_7.rdi_1 = tmp_9;
  var tmp_11 = $this;
  // Inline function 'com.lightningkite.kiteui.views.height' call
  var tmp_12 = $this.tb5_1.bb4_1.fb7_1.height;
  var tmp5_safe_receiver = (!(tmp_12 == null) ? typeof tmp_12 === 'string' : false) ? tmp_12 : null;
  var tmp_13;
  if (tmp5_safe_receiver == null) {
    tmp_13 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_14;
    if (!(tmp5_safe_receiver === $this.udi_1 || isBlank(tmp5_safe_receiver))) {
      tmp_14 = tmp5_safe_receiver;
    } else {
      tmp_14 = null;
    }
    tmp_13 = tmp_14;
  }
  tmp_11.sdi_1 = tmp_13;
  var tmp7_safe_receiver = parentElement == null ? null : parentElement.style;
  var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.display;
  var parentIsFlex = (tmp8_safe_receiver == null ? null : contains(tmp8_safe_receiver, 'flex')) === true;
  var tmp10_safe_receiver = parentElement == null ? null : parentElement.style;
  var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.flexDirection;
  var parentIsVertical = (tmp11_safe_receiver == null ? null : contains(tmp11_safe_receiver, 'col')) === true;
  // Inline function 'kotlin.text.isNotBlank' call
  var this_0 = element.style.flexGrow;
  var elementHasGrow = !isBlank(this_0);
  var elementIsStretch = element.style.alignSelf === 'stretch' || isBlank(element.style.alignSelf);
  var tmp_15 = $this;
  var tmp_16;
  if (parentIsFlex && (parentIsVertical && elementHasGrow) || (!parentIsVertical && elementIsStretch)) {
    tmp_16 = true;
  } else {
    var tmp12_safe_receiver = $this.rdi_1;
    tmp_16 = (tmp12_safe_receiver == null ? null : contains(tmp12_safe_receiver, '100%')) === true;
  }
  tmp_15.zdi_1 = tmp_16;
  var tmp_17 = $this;
  var tmp_18;
  if (parentIsFlex && (!parentIsVertical && elementHasGrow) || (parentIsVertical && elementIsStretch)) {
    tmp_18 = true;
  } else {
    var tmp13_safe_receiver = $this.sdi_1;
    tmp_18 = (tmp13_safe_receiver == null ? null : contains(tmp13_safe_receiver, '100%')) === true;
  }
  tmp_17.adj_1 = tmp_18;
  // Inline function 'com.lightningkite.kiteui.views.width' call
  var tmp_19 = $this.tb5_1.bb4_1.fb7_1.width;
  if (((!(tmp_19 == null) ? typeof tmp_19 === 'string' : false) ? tmp_19 : null) == $this.tdi_1) {
    if (parentIsFlex && !parentIsVertical) {
      // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
      $this.tb5_1.bb4_1.fb7_1.flexGrow = '999';
      // Inline function 'com.lightningkite.kiteui.views.width' call
      $this.tb5_1.bb4_1.fb7_1.width = 'unset';
    } else {
      // Inline function 'com.lightningkite.kiteui.views.width' call
      $this.tb5_1.bb4_1.fb7_1.width = '100%';
    }
  }
  // Inline function 'com.lightningkite.kiteui.views.height' call
  var tmp_20 = $this.tb5_1.bb4_1.fb7_1.height;
  if (((!(tmp_20 == null) ? typeof tmp_20 === 'string' : false) ? tmp_20 : null) == $this.udi_1) {
    if (parentIsFlex && parentIsVertical) {
      // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
      $this.tb5_1.bb4_1.fb7_1.flexGrow = '999';
      // Inline function 'com.lightningkite.kiteui.views.height' call
      $this.tb5_1.bb4_1.fb7_1.height = 'unset';
    } else {
      // Inline function 'com.lightningkite.kiteui.views.height' call
      $this.tb5_1.bb4_1.fb7_1.height = '100%';
    }
  }
  $this.xdi_1 = new (Size())(element.clientWidth, element.clientHeight);
  var tmp0 = $this.tb5_1.bb4_1;
  var tmp14_elvis_lhs = $this.rdi_1;
  // Inline function 'com.lightningkite.kiteui.views.width' call
  var value = tmp14_elvis_lhs == null ? 'unset' : tmp14_elvis_lhs;
  tmp0.fb7_1.width = value;
  var tmp0_0 = $this.tb5_1.bb4_1;
  var tmp15_elvis_lhs = $this.sdi_1;
  // Inline function 'com.lightningkite.kiteui.views.height' call
  var value_0 = tmp15_elvis_lhs == null ? 'unset' : tmp15_elvis_lhs;
  tmp0_0.fb7_1.height = value_0;
  var tmp0_1 = $this.tb5_1.bb4_1;
  var tmp16_elvis_lhs = $this.qdi_1;
  // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
  var value_1 = tmp16_elvis_lhs == null ? 'unset' : tmp16_elvis_lhs;
  tmp0_1.fb7_1.flexGrow = value_1;
}
function ProgrammaticLayout$internalAddChild$lambda(it) {
  // Inline function 'kotlin.js.asDynamic' call
  it.__existingMeasure = null;
  return Unit_instance;
}
function ProgrammaticLayout$internalAddChild$lambda$lambda(it) {
  // Inline function 'kotlin.js.asDynamic' call
  it.__existingMeasure = null;
  return Unit_instance;
}
var ProgrammaticLayout$inProgress$1Class;
function ProgrammaticLayout$inProgress$1() {
  if (ProgrammaticLayout$inProgress$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.qdp_1 = this$0;
      }
      gdg() {
        return this.qdp_1.kdi_1;
      }
      cdg() {
        return this.qdp_1.ldi_1;
      }
      ddg() {
        return this.qdp_1.mdi_1;
      }
      edg() {
        return this.qdp_1.ndi_1;
      }
      fdg() {
        return this.qdp_1.odi_1;
      }
      qdg(child, sizeConstraint) {
        var tmp = child.tb5_1.vb3_1;
        var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return new (Size())(0.0, 0.0);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var e = tmp_0;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = e.__existingMeasure;
        var existing = tmp_1 instanceof Size() ? tmp_1 : null;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = e.__existingMeasureConstraint;
        var existingConstraint = tmp_2 instanceof Size() ? tmp_2 : null;
        if (!(existing == null) && equals(existingConstraint, sizeConstraint))
          return existing;
        var m = measureByDuplicate(e, sizeConstraint);
        // Inline function 'kotlin.js.asDynamic' call
        e.__existingMeasure = m;
        // Inline function 'kotlin.js.asDynamic' call
        e.__existingMeasureConstraint = sizeConstraint;
        return m;
      }
      jdb(child, left, top, right, bottom) {
        var tmp;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.js.asDynamic' call
        if (child.__last_left == left) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp_1 = child.__last_top == top;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = child.__last_right == right;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = child.__last_bottom == bottom;
        } else {
          tmp = false;
        }
        if (tmp) {
          return Unit_instance;
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForStyle' call
        var tmp_2 = child.tb5_1.vb3_1;
        var tmp0_safe_receiver = tmp_2 instanceof HTMLElement ? tmp_2 : null;
        var tmp_3;
        if (tmp0_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForStyle' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_4 = tmp0_safe_receiver.__suppressMutationObserverStyle;
          var tmp0_elvis_lhs = tmp_4 instanceof ArrayList() ? tmp_4 : null;
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().w();
            // Inline function 'kotlin.js.asDynamic' call
            tmp0_safe_receiver.__suppressMutationObserverStyle = n;
            tmp_5 = n;
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          var e = tmp_5;
          var tmp0 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.position' call
          var value = 'absolute';
          tmp0.fb7_1.position = value;
          var tmp0_0 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.left' call
          var value_0 = left.toString() + 'px';
          tmp0_0.fb7_1.left = value_0;
          var tmp0_1 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.top' call
          var value_1 = top.toString() + 'px';
          tmp0_1.fb7_1.top = value_1;
          var tmp0_2 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.width' call
          var value_2 = (right - left).toString() + 'px';
          tmp0_2.fb7_1.width = value_2;
          var tmp0_3 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.height' call
          var value_3 = (bottom - top).toString() + 'px';
          tmp0_3.fb7_1.height = value_3;
          var tmp1_elvis_lhs = tmp0_safe_receiver.getAttribute('style');
          e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          var tmp0_4 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.position' call
          var value_4 = 'absolute';
          tmp0_4.fb7_1.position = value_4;
          var tmp0_5 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.left' call
          var value_5 = left.toString() + 'px';
          tmp0_5.fb7_1.left = value_5;
          var tmp0_6 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.top' call
          var value_6 = top.toString() + 'px';
          tmp0_6.fb7_1.top = value_6;
          var tmp0_7 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.width' call
          var value_7 = (right - left).toString() + 'px';
          tmp0_7.fb7_1.width = value_7;
          var tmp0_8 = child.tb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.height' call
          var value_8 = (bottom - top).toString() + 'px';
          tmp0_8.fb7_1.height = value_8;
        }
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_left = left;
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_top = top;
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_right = right;
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_bottom = bottom;
      }
    }
    initMetadataForClass($);
    ProgrammaticLayout$inProgress$1Class = $;
  }
  return ProgrammaticLayout$inProgress$1Class;
}
var ProgrammaticLayoutClass;
function ProgrammaticLayout() {
  if (ProgrammaticLayoutClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        var tmp0 = this.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'relative';
        tmp0.fb7_1.position = value;
        this.idi_1 = AllFull_instance;
        this.jdi_1 = null;
        this.kdi_1 = 0.0;
        this.ldi_1 = 0.0;
        this.mdi_1 = 0.0;
        this.ndi_1 = 0.0;
        this.odi_1 = 0.0;
        var tmp = this;
        tmp.pdi_1 = new (ProgrammaticLayout$inProgress$1())(this);
        this.qdi_1 = null;
        this.rdi_1 = null;
        this.sdi_1 = null;
        this.tdi_1 = null;
        this.udi_1 = null;
        this.vdi_1 = 0;
        this.wdi_1 = 0;
        this.xdi_1 = Companion_getInstance().sd0_1;
        this.ydi_1 = Companion_getInstance().sd0_1;
        this.zdi_1 = true;
        this.adj_1 = true;
        this.bdj_1 = false;
        this.cdj_1 = Companion_getInstance().sd0_1;
      }
      pdj(value) {
        this.idi_1 = value;
        this.ddj();
      }
      zba() {
        super.zba();
        var tmp = resizeObserver(ensureNotNull(this.rb6_1).tb5_1);
        onRemove(this, tmp.tah(() => {
          var tmp0_safe_receiver = this.jdi_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.fcv(['resizeObserver calls invalidateLayout()']);
          }
          remeasureConstrainedSize(this);
          this.ddj();
          return Unit_instance;
        }));
      }
      ub9(index, view) {
        super.ub9(index, view);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_0 = view.tb5_1;
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp0_safe_receiver.__existingMeasure = null;
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this_0.ub3_1.v(ProgrammaticLayout$internalAddChild$lambda);
        }
        var tmp0 = view.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'absolute';
        tmp0.fb7_1.position = value;
        var tmp_0 = mutationObserver(view.tb5_1, true);
        onRemove(view, tmp_0.tah(() => {
          // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
          var this_0 = view.tb5_1;
          var tmp0_safe_receiver = this_0.vb3_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp0_safe_receiver.__existingMeasure = null;
            tmp = Unit_instance;
          }
          if (tmp == null) {
            this_0.ub3_1.v(ProgrammaticLayout$internalAddChild$lambda$lambda);
          }
          var tmp_0;
          if (this.bdj_1) {
            return Unit_instance;
          }
          var tmp0_safe_receiver_0 = this.jdi_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.fcv(['child mutation calls invalidateLayout()']);
          }
          this.ddj();
          return Unit_instance;
        }));
        var tmp0_safe_receiver_0 = this.jdi_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.fcv(['child insert calls invalidateLayout()']);
        }
        this.ddj();
      }
      wb9(index) {
        super.wb9(index);
        var tmp0_safe_receiver = this.jdi_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['child remove calls invalidateLayout()']);
        }
        this.ddj();
      }
      zb8(value) {
        super.zb8(value);
        var tmp = this;
        var tmp0_safe_receiver = this.bb9();
        var tmp_0;
        var tmp_1 = tmp0_safe_receiver;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = get_px(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp.kdi_1 = tmp1_elvis_lhs == null ? get_px(this.kba().hb0_1) : tmp1_elvis_lhs;
      }
      bb9() {
        return super.bb9();
      }
      sb9(theme) {
        super.sb9(theme);
        var theme_0 = theme.eb1_1;
        var tmp = this;
        var tmp0_safe_receiver = this.bb9();
        var tmp_0;
        var tmp_1 = tmp0_safe_receiver;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = get_px(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp.kdi_1 = tmp1_elvis_lhs == null ? get_px(theme_0.hb0_1) : tmp1_elvis_lhs;
      }
      kb9() {
        super.kb9();
        var value = this.lb9();
        this.ldi_1 = get_viewUnits(value.lb2_1);
        this.mdi_1 = get_viewUnits(value.kb2_1);
        this.ndi_1 = get_viewUnits(value.mb2_1);
        this.odi_1 = get_viewUnits(value.nb2_1);
      }
      yb9() {
        super.yb9();
        var tmp0_safe_receiver = this.jdi_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['children clear calls invalidateLayout()']);
        }
        this.ddj();
      }
      ddj() {
        var tmp0_safe_receiver = this.jdi_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['invalidateLayout()']);
        }
        if (this.bdj_1)
          return Unit_instance;
        var tmp = window;
        tmp.setTimeout(() => {
          var tmp0_safe_receiver = this.jdi_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.fcv(['invalidateLayout timeout']);
          }
          var tmp = this.tb5_1.vb3_1;
          var tmp1_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var element = tmp_0;
          var tmp_1 = element.parentElement;
          var tmp2_elvis_lhs = tmp_1 instanceof HTMLElement ? tmp_1 : null;
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          var parentElement = tmp_2;
          this.cdj_1 = this.xdi_1;
          var natSize = this.idi_1.hdb(this, this.pdi_1, this.xdi_1);
          var tmp_3;
          if (!this.zdi_1) {
            this.tdi_1 = roundToInt(natSize.td0_1).toString() + 'px';
            element.style.width = ensureNotNull(this.tdi_1);
            tmp_3 = Unit_instance;
          }
          var tmp_4;
          if (!this.adj_1) {
            this.udi_1 = roundToInt(natSize.ud0_1).toString() + 'px';
            element.style.height = ensureNotNull(this.udi_1);
            tmp_4 = Unit_instance;
          }
          var s = new (Size())(this.zdi_1 ? this.xdi_1.td0_1 : natSize.td0_1, this.adj_1 ? this.xdi_1.ud0_1 : natSize.ud0_1);
          this.cdj_1 = s;
          this.idi_1.idb(this, this.pdi_1, s);
          var tmp_5 = window;
          tmp_5.setTimeout(() => {
            this.bdj_1 = false;
            return Unit_instance;
          }, 1);
          return Unit_instance;
        }, 1);
        this.bdj_1 = true;
      }
    }
    initMetadataForClass($, 'ProgrammaticLayout');
    ProgrammaticLayoutClass = $;
  }
  return ProgrammaticLayoutClass;
}
//region block: exports
export {
  ProgrammaticLayout as ProgrammaticLayout96iub9zkgjmh,
};
//endregion

//# sourceMappingURL=ProgrammaticLayout.js.mjs.map
